export default "__VITE_ASSET__BB2EKz2k__";